module.exports = __webpack_public_path__ + "img/ic_live_item2.614b3452.png";